<template>
  <div :class="mediumBtn ? 'medium-btn' : cascaderDefault ? 'cascader-btn' : 'tag-btn'">
    <el-cascader
      ref="cascader"
      v-model="cascaderValue"
      :class="{ 'active-btn': isActive }"
      :content="name"
      v-bind="$props"
      :popper-class="'cascader-popover ' + popperClass || ''"
      v-on="$listeners"
      @visible-change="changeUnfold"
    />
    <i
      v-if="!cascaderDefault && !isActive"
      :class="[unfold ? 'iconfont icon-arrow-up-s-line' : 'iconfont icon-arrow-down-s-line', 'unfold-icon', { 'active-icon': isActive }]"
      @click="handleOpenCascader"
    ></i>
  </div>
</template>

<script>
import { Cascader } from 'element-ui';
import i18n from '@/lang';

export default {
  name: 'CascaderButton',
  components: { ElCascader: Cascader },
  props: {
    ...Cascader.props,
    cascaderDefault: {
      type: Boolean,
      default: true
    },
    isActive: {
      type: Boolean,
      default: false
    },
    mediumBtn: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: i18n.t('+ 新增')
    }
  },
  data() {
    return {
      cascaderValue: this.value,
      unfold: false,
      dropDownVisible: false
    };
  },
  watch: {
    $props: {
      handler(val) {
        this.cascaderValue = val.value;
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    this.visibleChange('cascader');
  },
  methods: {
    handleOpenCascader() {
      this.dropDownVisible = !this.dropDownVisible;
      this.$refs.cascader.toggleDropDownVisible(this.dropDownVisible);
    },
    visibleChange(refName) {
      const ref = this.$refs[refName];
      let popper = ref.$refs.popper;
      if (popper.$el) popper = popper.$el;
      if (!Array.from(popper.children).some(v => v.className === 'el-cascader-menu__list')) {
        const el = document.createElement('div');
        el.style = 'border-top: solid 1px #E4E7ED; font-size: 16px; padding: 10px; color: #aaa;display: flex;justify-content: flex-end;';
        el.innerHTML = `<span id="cancel" class="pointer mr-2">${this.$t('取消')}</span>
          <span id="confirm" class="pointer text-main">${this.$t('确定')}</span>`;
        popper.appendChild(el);
        el.querySelector('#cancel').onclick = () => {
          this.cascaderValue = [];
          this.$emit('cancel');
          // 点击后弹层隐藏
          if (ref.toggleDropDownVisible) {
            ref.toggleDropDownVisible(false);
          } else {
            ref.visible = false;
          }
        };
        el.querySelector('#confirm').onclick = () => {
          // this.isActive = true;
          this.$emit('confirm');
          // 点击后弹层隐藏
          if (ref.toggleDropDownVisible) {
            ref.toggleDropDownVisible(false);
          } else {
            ref.visible = false;
          }
        };
      }
    },
    changeUnfold(val) {
      this.unfold = val;
    }
  }
};
</script>

<style lang="scss">
.cascader-popover {
  .el-cascader-panel {
    height: 200px;
  }
}
</style>
<style lang="scss" scoped>
.medium-btn {
  cursor: pointer;
  ::v-deep .el-cascader {
    width: 120px;
    height: 36px;
    line-height: 36px;
    border-radius: 3px;
    color: #fff;
    background-color: $main;
    border-color: $main;
    &::after {
      content: attr(content);
      width: 100%;
      position: absolute;
      left: 0;
      text-align: center;
    }
    &:hover,
    &:focus {
      background-color: $main-hover;
    }
    input::-webkit-input-placeholder {
      color: #fff;
    }
    .el-input,
    .el-cascader__tags {
      display: none;
    }
  }
}
.cascader-btn {
  cursor: pointer;
  ::v-deep .el-cascader {
    width: 90px;
    height: 32px;
    line-height: 32px !important;
    border-radius: 3px;
    color: #fff;
    background-color: $main;
    border-color: $main;
    &::after {
      content: attr(content);
      width: 100%;
      position: absolute;
      left: 0;
      text-align: center;
    }
    &:hover,
    &:focus {
      background-color: $main-hover;
    }
    input::-webkit-input-placeholder {
      color: #fff;
    }
    .el-input,
    .el-cascader__tags {
      display: none;
    }
  }
}
.tag-btn {
  cursor: pointer;
  color: rgba(0, 0, 0, 0.45);
  ::v-deep .el-cascader {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    width: 90px;
    height: 32px;
    border-radius: 3px;
    line-height: 30px;
    padding: 0;
    margin-top: 12px;
    margin-right: 10px;
    background-color: #fff;
    border: 1px solid #dcdfe6;
    &::after {
      content: attr(content);
      width: 100%;
      text-align: center;
    }
    &:hover,
    &:focus {
      color: $main;
      border-color: $main;
    }
    .el-input,
    .el-cascader__tags {
      display: none;
    }
  }
  &:hover,
  &:focus {
    color: $main;
    .el-cascader {
      border-color: $main;
    }
  }
  .unfold-icon {
    position: absolute;
    margin-left: 64px;
    top: 18px;
    font-size: 20px;
  }
}
.active-btn {
  color: $main;
  border: 1px solid $main !important;
}
.active-icon {
  color: $main;
}
</style>
